import { AddUsersToGroupDialogBody, AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState } from '../../../groups/components/AddUsersToGroupDialog';
import { GroupMembershipUpdateActionNotification } from '../notifications/GroupMembershipUpdateActionNotification';
import { IGroupInfo } from '../../../../ts/models/IGroupInfo';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { ListResult } from '../../../../ts/fetchers/ListResult';
import { Messages } from '../../../../codegen/Localize';
import { openReactActionDialog, ReactActionDialogBodyProps } from '../../../../commonInfra/dialogs/ReactActionDialog';
import { SearchSuggestionsService } from '../../../../ts/services/SearchSuggestionsService';
import { ServiceLocator } from '../../../../app/ServiceLocator';
import { Set } from '../../../../ts/models/Set';
import { SiteUsers } from '../../../services/resources/SiteUsers';
import { TabDialogWidth } from '../../../../commonInfra/dialogs/style/TabDialogWidth';
import { toNativePromise } from '../../../../commonInfra/utils/QUtils';


export type PropsForConfirmActionDialogBody = ReactActionDialogBodyProps<AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState>;

export namespace AddUsersToGroupAction {
  export function renderActionName(_: AddUsersToGroupDialogBodyProps, state: AddUsersToGroupDialogState): string {
    return Messages.confirmAddUsersToGroup({ADD_USER_COUNT_LOC: String(state.selectedUserIds.length)});
  }

  async function getInGroupSiteUserInfoList(group: IGroupInfo): Promise<ListResult<ISiteUserInfo>> {
    return toNativePromise(SiteUsers.instance.getUsersByGroupIds([group.id]));
  }

  export async function showAddUsersToGroupDialog(group: IGroupInfo): Promise<IResult> {
    const usersInGroup = await getInGroupSiteUserInfoList(group);
    const dialogInstance = openReactActionDialog<AddUsersToGroupDialogBodyProps, AddUsersToGroupDialogState, IResult>({
      actionName: renderActionName,
      action: (_, state) => {
        const addUsersToGroupPromise = SiteUsers.instance.addToGroups(state.selectedUserIds, [group.id]).then(
          (result: any) => {
            // show toast
            GroupMembershipUpdateActionNotification.notify(
              result,
              state.selectedIUserInfoSet,
              1,
              group.name,
              0,
              ''
            );
            return result;
          }
        );
        return toNativePromise(addUsersToGroupPromise);
      },
      actionDisabled: (_, state) => {return state.selectedUserIds.length === 0;},
      bodyComponent: AddUsersToGroupDialogBody,
      dialogWidth: TabDialogWidth.width700px,
      dismissDialogOnActionFailed: false,
      initialDialogState: {
        addableResultsList: [],
        selectedUserIds: [],
        selectedIUserInfoSet: new Set((item) => item.id)
      },
      initialBodyProps: {
        group,
        getQuery: ServiceLocator.get<SearchSuggestionsService>('SearchSuggestionsService').usersBySiteRoleAndSearch,
        inGroupUsersList: usersInGroup.items,
      },
      title: Messages.addUsers(),
    });

    return toNativePromise(dialogInstance.result);
  }
}

export type AddUsersToGroupAction = typeof AddUsersToGroupAction;